module.exports = __webpack_public_path__ + "img/mg.f2d3fca1.svg";